import { FooterComponentItem } from '@app-shared/components/footers/footer.model';
import { ClientConfig, DEFAULT_CLIENT_CONFIG } from './config.base';
import { navigationRoutes as BaseLinks, RouteParams } from './links.base';
import { SatrackFooterComponent } from '@app-shared/components/footers/satrack-footer/satrack-footer.component';

export const CLIENT_CONFIG: ClientConfig = {
  clientName: 'satrack',
  ...DEFAULT_CLIENT_CONFIG,
  logo: {
    lightLogo: 'assets/satrack/light-logo.svg',
    darkLogo: 'assets/satrack/dark-logo.svg',
    alt: 'Satrack',
    width: '120px',
    height: '40px',
  },
  landingPageDetails: {
    backgroundImage: {
      src: 'assets/satrack/login-page-bg.png',
    },
    brandImage: {
      src: 'assets/satrack/dark-logo.svg',
    },
    headerImage: {
      src: 'assets/satrack/dark-logo.svg',
    },
    tagline: 'satrackTagline',
    footer: new FooterComponentItem(SatrackFooterComponent),
    headerColor: '#1D2F80',
    largerFooter: true,
  },
  showLandingPage: true,
};

export const navigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedRoutes.map((x) => BaseLinks[x]);
